import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
import * as turf from '@turf/turf';

/**
 * Generated class for the ComputeDistancePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'computeDistance',
})
export class ComputeDistancePipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value, userLocation, s = 'away') {
    const dest = _.get(value, 'coordinates'),
      user = _.get(userLocation, 'coordinates'),
      destLat = <any>_.last(dest),
      destLon = <any>_.first(dest),
      userLat = <any>_.last(user),
      userLon = <any>_.first(user);

    if (!userLon || !userLat || !destLon || !destLat) {
      return '';
    }

    return (
      _.round(
        turf.distance(
          turf.point([userLon, userLat]),
          turf.point([destLon, destLat]),
          { units: 'miles' }
        ),
        0
      ) +
      ' mi. ' +
      s
    ).trim();
  }
}



// WEBPACK FOOTER //
// ./src/pipes/compute-distance/compute-distance.ts